import { Observer } from "mobx-react-lite"
import React from "react"
import { QuestionIcon } from "../../shared/icon"
import { PageType, StockSubType } from "../../shared/pagetype"
import { single_quote, quote_item_name } from "../../shared/quotedata/index"
import { store } from "./store"

export function AHPrice(props: { pagetype: PageType }) {

  const clickAH = (data:any)=>{
    window.location.href = `/quote/stock/${data.f257}.${data.f256}.html`;
  }

  return (
    <Observer>
      {() => (
        <>
          {store.StockDetail && store.StockDetail.f256 && store.StockDetail.f256 != '-' && (props.pagetype == PageType.沪深A股) && (
            <div className="ah-notice">
              <div className="ah-container" onClick={()=>clickAH(store.StockDetail)}>
                <p>
                  H股报价：
                  {single_quote[quote_item_name.H股报价](store.StockDetail).element}
                </p>
                <p>
                  <QuestionIcon/>
                  (A/H)比价={single_quote[quote_item_name["(A/H)比价"]](store.StockDetail).element}
                  <i className="arrow-right-new"></i>
                </p>
              </div>
            </div>
          )}
        </>
      )}
    </Observer>
  )
}
